import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-full min-w-0" }
const _hoisted_2 = { class: "hidden lg:block w-full min-w-0" }
const _hoisted_3 = { class: "overflow-x-auto overscroll-x-contain" }
const _hoisted_4 = { class: "w-full min-w-[64rem] border-separate border-spacing-0 text-left" }
const _hoisted_5 = { class: "bg-gradient-to-r from-slate-50 to-slate-100 sticky top-0 z-10" }
const _hoisted_6 = { class: "divide-y divide-slate-100 bg-white" }
const _hoisted_7 = { class: "px-6 py-5 whitespace-nowrap" }
const _hoisted_8 = { class: "font-semibold text-slate-900" }
const _hoisted_9 = { class: "px-6 py-4" }
const _hoisted_10 = { class: "font-semibold text-slate-900" }
const _hoisted_11 = { class: "text-xs text-slate-500 mt-1" }
const _hoisted_12 = { class: "px-6 py-4 text-slate-600" }
const _hoisted_13 = { class: "text-sm" }
const _hoisted_14 = { class: "px-6 py-4" }
const _hoisted_15 = {
  key: 1,
  class: "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-500"
}
const _hoisted_16 = { class: "px-6 py-4" }
const _hoisted_17 = { class: "text-lg font-bold text-slate-900" }
const _hoisted_18 = { class: "px-6 py-4" }
const _hoisted_19 = {
  key: 1,
  class: "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-500"
}
const _hoisted_20 = { class: "px-6 py-4" }
const _hoisted_21 = { class: "flex items-center gap-2 text-slate-700" }
const _hoisted_22 = {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_23 = ["d"]
const _hoisted_24 = { class: "text-sm font-medium" }
const _hoisted_25 = { class: "px-6 py-4 text-sm text-slate-600" }
const _hoisted_26 = { class: "px-6 py-4 whitespace-nowrap flex gap-2" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "mt-5 lg:hidden space-y-4 px-3 sm:px-0" }
const _hoisted_30 = { class: "bg-gradient-to-r from-slate-50 to-slate-100 px-4 py-3 border-b border-slate-200" }
const _hoisted_31 = { class: "flex items-start justify-between gap-3" }
const _hoisted_32 = { class: "flex items-start gap-3 flex-1" }
const _hoisted_33 = { class: "flex-shrink-0 w-8 h-8 flex items-center justify-center bg-slate-200 rounded-full font-bold text-slate-700 text-sm" }
const _hoisted_34 = { class: "flex-1 min-w-0" }
const _hoisted_35 = { class: "font-bold text-slate-900 text-base" }
const _hoisted_36 = { class: "text-xs text-slate-500 mt-1" }
const _hoisted_37 = { class: "px-4 py-3 space-y-3" }
const _hoisted_38 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_39 = { class: "bg-slate-50 rounded-lg px-3 py-2" }
const _hoisted_40 = { class: "text-lg font-bold text-slate-900 mt-1" }
const _hoisted_41 = { class: "bg-slate-50 rounded-lg px-3 py-2" }
const _hoisted_42 = { class: "flex items-center gap-1.5 mt-1" }
const _hoisted_43 = {
  class: "w-4 h-4 text-slate-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_44 = ["d"]
const _hoisted_45 = { class: "text-sm font-medium text-slate-800" }
const _hoisted_46 = { class: "bg-slate-50 rounded-lg px-3 py-2" }
const _hoisted_47 = {
  key: 1,
  class: "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium mt-1 bg-gray-100 text-gray-500"
}
const _hoisted_48 = { class: "bg-slate-50 rounded-lg px-3 py-2" }
const _hoisted_49 = {
  key: 1,
  class: "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium mt-1 bg-gray-100 text-gray-500"
}
const _hoisted_50 = { class: "bg-slate-50 rounded-lg px-3 py-2" }
const _hoisted_51 = { class: "text-sm text-slate-700 mt-1" }
const _hoisted_52 = { class: "text-sm text-slate-700" }
const _hoisted_53 = { class: "flex items-center justify-between py-2 px-3 bg-slate-50 rounded-lg" }
const _hoisted_54 = { class: "text-sm text-slate-700 font-medium" }
const _hoisted_55 = { class: "flex gap-2 pt-2" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["onClick"]

import { ref, watch } from "vue";
import { Pedido } from "../../interfaces/gpedPedido.inteface";

interface Props {
  pedidos: Pedido[];
  sortField: string | null;
  sortDirection: "asc" | "desc";
  isDelete?: boolean;
  currentPage?: number;
  pageSize?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'pedidosCompletadosTable',
  props: {
    pedidos: {},
    sortField: {},
    sortDirection: {},
    isDelete: { type: Boolean },
    currentPage: { default: 1 },
    pageSize: { default: 10 }
  },
  emits: ["sort", "viewDetails", "descargar-pdf"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Calcular el índice base según la página actual
const getGlobalIndex = (localIndex: number) => {
  return (props.currentPage - 1) * props.pageSize + localIndex + 1;
};

const showDeleteModal = ref(false);
const pedidoToDelete = ref<{ id: string; cliente: string } | null>(null);
const isDeleting = ref(false);

const formatDate = (dateString: string) =>
  new Date(dateString).toLocaleDateString("es-ES", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

const formatCurrency = (value: string) =>
  new Intl.NumberFormat("es-PE", {
    style: "currency",
    currency: "PEN",
  }).format(parseFloat(value));

const getEstadoClass = (estado: string) => {
  const estados: Record<string, string> = {
    Pendiente: "bg-yellow-100 text-yellow-700",
    "En Proceso": "bg-blue-100 text-blue-700",
    Completado: "bg-green-100 text-green-700",
    Cancelado: "bg-red-100 text-red-700",
    Entregado: "bg-purple-100 text-purple-700",
  };
  return estados[estado] || "bg-gray-100 text-gray-700";
};

const getMetodoPagoIcon = (metodo: string) => {
  if (metodo.toLowerCase().includes("efectivo")) {
    return "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z";
  } else if (
    metodo.toLowerCase().includes("tarjeta") ||
    metodo.toLowerCase().includes("visa") ||
    metodo.toLowerCase().includes("mastercard")
  ) {
    return "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z";
  } else if (metodo.toLowerCase().includes("transferencia")) {
    return "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4";
  }
  return "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z";
};

const openDeleteModal = (id: string, cliente: string) => {
  pedidoToDelete.value = { id, cliente };
  showDeleteModal.value = true;
};

watch(
  () => props.isDelete,
  (newVal) => {
    if (newVal) {
      showDeleteModal.value = false;
      pedidoToDelete.value = null;
      isDeleting.value = false;
    }
  }
);

const getSortIcon = (field: string) => {
  if (props.sortField !== field) {
    return "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4";
  }
  return props.sortDirection === "asc"
    ? "M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
    : "M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("thead", _hoisted_5, [
            _createElementVNode("tr", null, [
              _cache[6] || (_cache[6] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xl font-bold text-slate-800 uppercase tracking-wider" }, " # ", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " Cliente ", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " Documento ", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " Comprobante ", -1)),
              _createElementVNode("th", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('sort', 'totalPedido'))),
                class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase cursor-pointer hover:bg-slate-200"
              }, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "flex items-center gap-2" }, [
                  _createElementVNode("span", null, "Total")
                ], -1)
              ]))]),
              _cache[10] || (_cache[10] = _createElementVNode("th", null, [
                _createElementVNode("div", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase cursor-pointer hover:bg-slate-200" }, [
                  _createElementVNode("span", null, "Método compra")
                ])
              ], -1)),
              _createElementVNode("th", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('sort', 'metodoPago'))),
                class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase cursor-pointer hover:bg-slate-200"
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "flex items-center gap-2" }, [
                  _createElementVNode("span", null, "Método Pago")
                ], -1)
              ]))]),
              _createElementVNode("th", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('sort', 'createdAt'))),
                class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase cursor-pointer hover:bg-slate-200"
              }, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "flex items-center gap-2" }, [
                  _createElementVNode("span", null, "Fecha")
                ], -1)
              ]))]),
              _cache[11] || (_cache[11] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " Acciones ", -1))
            ])
          ]),
          _createElementVNode("tbody", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pedidos, (pedido, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: pedido.id,
                class: "hover:bg-slate-50 transition-colors"
              }, [
                _createElementVNode("td", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(getGlobalIndex(index)), 1)
                ]),
                _createElementVNode("td", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(pedido.cliente.nombreCliente) + " " + _toDisplayString(pedido.cliente.apellidoCliente), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(pedido.cliente.correoCliente), 1)
                ]),
                _createElementVNode("td", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(pedido.cliente.nroDocumento), 1)
                ]),
                _createElementVNode("td", _hoisted_14, [
                  (pedido.tipoComprobante)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["inline-flex items-center px-3 py-1 rounded-full text-xs font-medium", 
                  pedido.tipoComprobante === 'Factura'
                    ? 'bg-blue-100 text-blue-700'
                    : 'bg-green-100 text-green-700'
                ])
                      }, _toDisplayString(pedido.tipoComprobante), 3))
                    : (_openBlock(), _createElementBlock("span", _hoisted_15, " N/A "))
                ]),
                _createElementVNode("td", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(formatCurrency(pedido.totalPedido)), 1)
                ]),
                _createElementVNode("td", _hoisted_18, [
                  (pedido.metodoCompra)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["inline-flex items-center px-3 py-1 rounded-full text-xs font-medium", 
                  pedido.metodoCompra === 'Entrega a Domicilio'
                    ? 'bg-indigo-100 text-indigo-700'
                    : 'bg-teal-100 text-teal-700'
                ])
                      }, _toDisplayString(pedido.metodoCompra), 3))
                    : (_openBlock(), _createElementBlock("span", _hoisted_19, " N/A "))
                ]),
                _createElementVNode("td", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_22, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: getMetodoPagoIcon(pedido.metodoPago.nombre)
                      }, null, 8, _hoisted_23)
                    ])),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(pedido.metodoPago.nombre), 1)
                  ])
                ]),
                _createElementVNode("td", _hoisted_25, _toDisplayString(formatDate(pedido.createdAt)), 1),
                _createElementVNode("td", _hoisted_26, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (emit('viewDetails', pedido.id)),
                    class: "p-2 text-green-600 hover:bg-green-50 rounded-lg",
                    title: "Ver detalles"
                  }, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("svg", {
                      class: "w-5 h-5",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      }),
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      })
                    ], -1)
                  ]))], 8, _hoisted_27),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.$emit('descargar-pdf', pedido.id)),
                    class: "p-2 text-blue-600 hover:bg-blue-100 rounded-lg",
                    title: "Descargar PDF"
                  }, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("svg", {
                      class: "w-4 h-4",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                      })
                    ], -1)
                  ]))], 8, _hoisted_28)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pedidos, (pedido, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: pedido.id,
          class: "bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden hover:shadow-md transition-shadow"
        }, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, _toDisplayString(getGlobalIndex(index)), 1),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("h3", _hoisted_35, _toDisplayString(pedido.cliente.nombreCliente) + " " + _toDisplayString(pedido.cliente.apellidoCliente), 1),
                  _createElementVNode("p", _hoisted_36, _toDisplayString(pedido.cliente.nroDocumento), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase block" }, "Total", -1)),
                _createElementVNode("p", _hoisted_40, _toDisplayString(formatCurrency(pedido.totalPedido)), 1)
              ]),
              _createElementVNode("div", _hoisted_41, [
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase block" }, "Pago", -1)),
                _createElementVNode("div", _hoisted_42, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_43, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: getMetodoPagoIcon(pedido.metodoPago.nombre)
                    }, null, 8, _hoisted_44)
                  ])),
                  _createElementVNode("p", _hoisted_45, _toDisplayString(pedido.metodoPago.nombre), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase block" }, "Comprobante", -1)),
              (pedido.tipoComprobante)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded-full text-xs font-medium mt-1", 
                pedido.tipoComprobante === 'Factura'
                  ? 'bg-blue-100 text-blue-700'
                  : 'bg-green-100 text-green-700'
              ])
                  }, _toDisplayString(pedido.tipoComprobante), 3))
                : (_openBlock(), _createElementBlock("span", _hoisted_47, " N/A ")),
              _createElementVNode("div", _hoisted_48, [
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase block" }, "Método de Compra", -1)),
                (pedido.metodoCompra)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded-full text-xs font-medium mt-1", 
                  pedido.metodoCompra === 'Entrega a Domicilio'
                    ? 'bg-indigo-100 text-indigo-700'
                    : 'bg-teal-100 text-teal-700'
                ])
                    }, _toDisplayString(pedido.metodoCompra), 3))
                  : (_openBlock(), _createElementBlock("span", _hoisted_49, " N/A "))
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase block" }, "Contacto", -1)),
              _createElementVNode("p", _hoisted_51, _toDisplayString(pedido.cliente.correoCliente), 1),
              _createElementVNode("p", _hoisted_52, _toDisplayString(pedido.cliente.telefono), 1)
            ]),
            _createElementVNode("div", _hoisted_53, [
              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase" }, "Fecha", -1)),
              _createElementVNode("span", _hoisted_54, _toDisplayString(formatDate(pedido.createdAt)), 1)
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("button", {
                onClick: ($event: any) => (emit('viewDetails', pedido.id)),
                class: "flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 transition-colors font-medium text-sm"
              }, [...(_cache[20] || (_cache[20] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  }),
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  })
                ], -1),
                _createTextVNode(" Ver ", -1)
              ]))], 8, _hoisted_56),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.$emit('descargar-pdf', pedido.id)),
                class: "flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors font-medium text-sm"
              }, [...(_cache[21] || (_cache[21] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                  })
                ], -1),
                _createTextVNode(" pdf ", -1)
              ]))], 8, _hoisted_57)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})